<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        scrollable
        max-width="600px"
    >
      <v-card>
        <v-card-title>Issue/Renew Book</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="issue_up_to"
                      label="Issue Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="issue_up_to"
                    @input="menu = false"
                    :max="valid_up_to"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field outlined dense label="Scan Student Id" v-model="barcode" autofocus
                            @input="__searchUser" clearable
                            @click:clear="clearSearch()"
              ></v-text-field>
              <v-list dense>
                <v-list-item-group
                    color="primary"
                >
                  <v-list-item
                      v-for="(usr, i) in users"
                      :key="i" :disabled="!usr.enable_library"
                  >
                    <v-list-item-content @click="checkTotalIssuedBook(usr)">
                      <v-list-item-title>
                        <span>{{ usr.display_text }}</span>
                        <span class="badge badge-primary ml-3" v-if="!usr.enable_library">Membership Expired</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <div class="row ml-3" v-if="selected_user && selected_user.id">
              <!--        <h5>Student/Teacher Information</h5>-->
              <div class="col-3">
                <img v-if="selected_user.image_path && selected_user.image_path['real']"
                     :src="selected_user.image_path['real']" id="instImage"
                     style="width: 70px; height: 70px; border-radius: 100%; margin-top: 4%; margin-left: -4%;">
                <img v-else
                     :src="'https://images.unsplash.com/photo-1509114397022-ed747cca3f65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80'"
                     style="width: 70px; height: 70px; border-radius: 100%; margin-top: 4%; margin-left: -4%;">
              </div>
              <div class="col-9">
         <span>
              <h5>{{ selected_user.full_name }}</h5>
           <p>
             <span>{{ selected_user.phone }}, {{ selected_user.email }}</span><br>
              <span v-if="selected_user.setting && selected_user.setting.academic_year">{{
                  selected_user.setting.academic_year
                }}, </span>
              <span v-if="selected_user.setting && selected_user.setting.program_title">{{
                  selected_user.setting.program_title
                }}</span><br>
              <span v-if="selected_user.setting && selected_user.setting.current_semester_title">{{
                  selected_user.setting.current_semester_title
                }}
                - {{ selected_user.setting.current_class_title }}
              </span><br>
             <span class="" v-if="user_details.currently_issued && user_details.currently_issued.length">Total Book Issued:
              <v-chip color="blue" class="text-white">{{ user_details.currently_issued.length }}</v-chip>
             </span>
           </p>

                </span>
              </div>
            </div>
          </v-row>
          <v-row v-if="disable_issue_2">
            <v-col>
              <v-alert color="red" class="text-white">User is not allowed to issue more books</v-alert>
            </v-col>
          </v-row>
          <v-row v-if="disable_issue_1">
            <v-col>
              <v-alert color="red" class="text-white">This book has already been issued.</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-btn
              depressed class="btn btn-secondary"
              text
              @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn :disabled="disable_issue" v-if="selected_user && selected_user.id" :loading="loading"
                 depressed class="btn btn-primary text-white"
                 text
                 @click="issueBook"
          >
            Issue

          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import IssueService from "@/core/services/library/issue/IssueService";
import UserInfoService from "@/core/services/user/UserInfoService";
import BookMixin from "@/mixins/BookMixin";

const issueService = new IssueService();
const userService = new UserInfoService();

export default {
  name: "IssueBook",
  mixins: [BookMixin],
  props: ['setting', 'dialog', 'book_accession'],
  data() {
    return {
      menu: false,
      loading: false,
      barcode: null,
      users: [],
      selected_user: {},
      issue_up_to: null,
      user_details: {},
      disable_issue: false,
      disable_issue_1: false,
      disable_issue_2: false,
    }
  }, computed: {
    valid_up_to() {
      this.issue_up_to = this.$moment(new Date()).add(this.setting.renew_day, 'day').format('YYYY-MM-DD');
      return this.$moment(new Date()).add(this.setting.renew_day, 'day').format('YYYY-MM-DD')
    }
  }, methods: {
    __searchUser() {
      if (!this.barcode || this.barcode.length <= 2)
        return
      let data = {barcode: this.barcode}
      this.searchUser(data)
    },
    closeDialog() {
      this.clearSearch();
      this.$emit('refresh')
    },
    refreshSelectedUser(){
      this.users= [],
      this.selected_user =  null
    },
    issueBook() {
      this.$confirm({
        message: `Are you sure you want to issue this book for user?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.loading = true;
            let setting = this.selected_user.setting;
            let data = {
              book_id: this.book_accession.book_id,
              book_accession_id: this.book_accession.id,
              user_id: this.selected_user.id,
              program_id: setting ? setting.program_id : null,
              grade_id: setting ? setting.grade_id : null,
              class_id: setting ? setting.class_id : null,
            }
            issueService.store(data).then(response => {
              this.loading = false;
              this.clearSearch()
              this.closeDialog();
            }).catch(error => {
              this.$snotify.error("Something went wrong. Please try again later")
            }).finally(() => {
              this.loading = false;
            })
          }
        }
      });
    },
    clearSearch() {
      // alert("Hello")
      this.selected_user = {};
      this.users = [];
      this.barcode = null
    },
    checkTotalIssuedBook(usr) {
      this.loading = true
      this.selected_user = usr;
      issueService.getByStudentCardId(this.selected_user.id_card_no).then(response => {
        this.loading = false
        this.user_details = response.data;
        this.checkForDisableIssue();

      }).catch(error => {
        this.$snotify.error("Error extraction user detail")
      }).finally(() => {
        this.loading = false
      })
    },
    checkForDisableIssue() {
      this.disable_issue = false
      this.disable_issue_2 = false
      this.disable_issue_1 = false
      if (this.user_details && this.user_details.user && this.user_details.user.library_setting.max_book_issue_allowed) {
        if (this.user_details.currently_issued.length >= 0) {
          if (this.user_details.currently_issued.length >= this.user_details.user.library_setting.max_book_issue_allowed) {
            this.disable_issue_2 = true
            this.disable_issue = true
          } else {
            this.user_details.currently_issued.forEach(ele => {
              if (this.book_accession.book_id == ele.book_id) {
                this.disable_issue_1 = true;
                this.disable_issue = true;
                return
              }
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>